import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor() {}

  get loading(): boolean {
    return this.loading$.value;
  }

  set loading(value: boolean) {
    this.loading$.next(value);
  }
}
